import * as configcat from "configcat-js";

let configCatClient: configcat.IConfigCatClient | null = null;

const offlineClient = {
  getAllValuesAsync: async () => [],
  getValueAsync: async (_key: string, defaultValue: any) => defaultValue,
  snapshot: () => ({ fetchedConfig: { settings: {} } }),
  dispose: () => {},
} as unknown as configcat.IConfigCatClient;

export function useConfigcat() {
  const config = useRuntimeConfig();
  const { CONFIGCAT_SDK_KEY } = config.public;

  if (!CONFIGCAT_SDK_KEY) {
    return { configCatClient: offlineClient };
  }

  if (!configCatClient) {
    try {
      configCatClient = configcat.getClient(CONFIGCAT_SDK_KEY, configcat.PollingMode.AutoPoll, {
        pollIntervalSeconds: 60,
      });
    } catch {
      console.warn("[configcat] Failed to initialize client, using offline mode");
      return { configCatClient: offlineClient };
    }
  }

  return {
    configCatClient,
  };
}
